import { useMemo, useRef } from 'react';
import usePromoJanuaryBonusModal from './usePromoJanuaryBonusModal';
import usePromoTeensModalBot from './usePromoTeensModalBot';
import usePromoTeensModalTelegram from './usePromoTeensModalTelegram';
import useNewSeasonModal from './useNewSeasoneModal';
import useEsteeLauderModal from './useEsteeLauderModal';
import useMarch8ModalHoliday from './useMarch8ModalHoliday';
import useRamadanModal from './useRamadanModal';
import useServiceData from '../../../../../hooks/useServiceData';
import { getIsAvailableEvent } from '../../../../../constants/events';
import { defaultStore } from '../../../../../translations';
// import usePromoPHLModal from './usePromoPHLModal';
// import useNewYearModalBonuses from './useNewYearModalBonuses';
// import useNewYearModal from './useNewYearModal';
import { getIsDebug } from '../../../../../utils/scene/debug/getIsDebug';

let showedId;

export default function useModalsWithRedirect({ isShowOneModalOnSession = true, isShowOneModalOnMount = false } = {}) {
  // const newYearModals = useNewYearModal();
  // const promoModals = usePromoPHLModal();
  // const bonusesModal = useNewYearModalBonuses();
  const promoTeensModalBot = usePromoTeensModalBot();
  const promoTeensModalTelegram = usePromoTeensModalTelegram();
  const januaryBonusModals = usePromoJanuaryBonusModal();
  const newSeasonModal = useNewSeasonModal();
  const esteeLauderModal = useEsteeLauderModal();
  const march8ModalHoliday = useMarch8ModalHoliday();
  const ramadanModal = useRamadanModal();
  const { get } = useServiceData();
  const showedMountId = useRef();

  if (isShowOneModalOnSession && isShowOneModalOnMount && getIsDebug()) console.error('properties conflict');

  return useMemo(() => {
    const modalsData = get('modalsData') ?? {};

    const modals = [
      /*bonusesModal,*/
      /*newYearModals,*/
      /*promoModals,*/
      januaryBonusModals,
      promoTeensModalBot,
      promoTeensModalTelegram,
      newSeasonModal,
      march8ModalHoliday,
      esteeLauderModal,
      ramadanModal,
    ]
      .flat(Number.MAX_VALUE)
      .filter((modal) => {
        if (!modal) return false;
        // Если у модалки есть event, проверяем его доступность
        if (modal.event && !getIsAvailableEvent(defaultStore, modal.event)) return false;
        return true;
      });

    const currentModal = (() => {
      if (!!showedId) return modals.find(({ id: modalId }) => modalId === showedId);
      if (!!showedMountId.current) return modals.find(({ id: modalId }) => modalId === showedMountId.current);
      return modals.find(({ id }) => !modalsData[id]);
    })();

    if (isShowOneModalOnSession) showedId = currentModal?.id;
    if (isShowOneModalOnMount) showedMountId.current = currentModal?.id;

    return currentModal;
  }, [
    isShowOneModalOnSession,
    isShowOneModalOnMount,
    // bonusesModal,
    // newYearModals,
    // promoModals,
    januaryBonusModals,
    promoTeensModalBot,
    promoTeensModalTelegram,
    newSeasonModal,
    march8ModalHoliday,
    esteeLauderModal,
    ramadanModal,
  ]);
}
